import "./devParcel.efc2538a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9fb6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9fb6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");





var $2q7Wm = parcelRequire("2q7Wm");
parcelRequire("dktVJ");

var $6KOho = parcelRequire("6KOho");

var $fhN3L = parcelRequire("fhN3L");

var $6AR8M = parcelRequire("6AR8M");
// inicialización firebase
// TODO: config.firebaseConfig.authDomain: "localhost", // cambiar en producción a "educawood.gsic.uva.es",
let $2c4fb5aaf204f29b$var$app = (0, $fhN3L.initializeApp)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).firebaseConfig);
let $2c4fb5aaf204f29b$var$provider;
// idioma
const $2c4fb5aaf204f29b$var$path = window.location.pathname;
let $2c4fb5aaf204f29b$var$lang = localStorage.getItem('lang');
if (!$2c4fb5aaf204f29b$var$lang) {
    // elijo automáticamente a partir del lenguaje del navegador
    const preflangs = window.navigator.languages || [
        window.navigator.language || window.navigator.userLanguage
    ];
    for (let ltag of preflangs){
        const langev = ltag.substring(0, 2);
        if ((0, $2q7Wm.default).contains((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs, langev)) {
            $2c4fb5aaf204f29b$var$lang = langev;
            break;
        }
    }
    if (!$2c4fb5aaf204f29b$var$lang) $2c4fb5aaf204f29b$var$lang = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs[0]; // inglés
}
if ($2c4fb5aaf204f29b$var$path === "/" && $2c4fb5aaf204f29b$var$lang === "es") window.location.href = 'es';
else if ($2c4fb5aaf204f29b$var$path === "/es" && $2c4fb5aaf204f29b$var$lang === "en") window.location.href = '..';
else {
    // rutina autenticación
    $2c4fb5aaf204f29b$var$autenticacionLanding();
    // listener del cambio de idioma
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.lang').click(function() {
        // Prevent the default behavior of the link
        event.preventDefault();
        // recupero idioma
        let nlang = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("tag");
        // guardo en localstorage
        localStorage.setItem('lang', nlang);
        // miro si hay que cambiar
        if ($2c4fb5aaf204f29b$var$path === "/" && nlang === "es") window.location.href = 'es';
        else if ($2c4fb5aaf204f29b$var$path === "/es" && nlang === "en") window.location.href = '..';
    });
}
function $2c4fb5aaf204f29b$var$clickSignin(e) {
    e.preventDefault(); // Prevent the default behavior of the hyperlink
    const auth = (0, $6AR8M.getAuth)();
    (0, $6AR8M.signInWithRedirect)(auth, $2c4fb5aaf204f29b$var$provider);
}
function $2c4fb5aaf204f29b$var$clickSignout(e) {
    e.preventDefault(); // Prevent the default behavior of the hyperlink
    const auth = (0, $6AR8M.getAuth)();
    (0, $6AR8M.signOut)(auth);
}
function $2c4fb5aaf204f29b$var$autenticacionLanding() {
    // inicialización
    $2c4fb5aaf204f29b$var$provider = new (0, $6AR8M.GoogleAuthProvider)();
    const auth = (0, $6AR8M.getAuth)();
    auth.useDeviceLanguage();
    // handler para detectar si hay usuario
    (0, $6AR8M.onAuthStateChanged)(auth, async (user)=>{
        if (user) {
            // muestro avatar con dropdown de signout (landing)
            // no guardo user			
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#aProfile").attr("href", "/user/" + user.uid);
            const htmlImg = user.photoURL ? '<img class="avatar avatar-32 avatar-sm-48 bg-light rounded-circle text-white" \
						src="' + user.photoURL + '" referrerpolicy="no-referrer">' : '<img class="avatar avatar-32 avatar-sm-48 bg-light rounded-circle text-white p-1 p-sm-2" \
						src="https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg" \
						referrerpolicy="no-referrer">';
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonAvatar").html(htmlImg);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#divAvatar").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonSignin").addClass("d-none");
        } else {
            // muestro botón de signin (landing)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#divAvatar").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonSignin").removeClass("d-none");
        }
    });
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click($2c4fb5aaf204f29b$var$clickSignin);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click($2c4fb5aaf204f29b$var$clickSignout);
}


//# sourceMappingURL=devParcel.e8be62f1.js.map
